export enum Languages {
  ENGLISH = "English",
  FRENCH = "Français",
  ITALIAN = "Italiano",
  SWEDEN = "Svenska",
}
